import React, { useState } from 'react'
import Input from '../Form Elements/Input'
import Button from '../../ui/Button'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '../../helpers/Axios'
import LogError from '../LogError'

function AddAddress({ onClose }) {

    const [data, setData] = useState({
        firstname: "",
        lastname: "",
        company: "",
        address_1: "",
        address_2: "",
        city: "",
        country: "",
        phone: ""
    })

    const queryClient = useQueryClient()

    // handle inputs
    const handleInput = (e) => {
        const { id, value } = e.target;
        setData({ ...data, [id]: value })
    }


    // Adding
    const { mutate, isPending, error } = useMutation({
        mutationFn: async (formData) => {
            return apiClient.post(`/address/add`, formData)
        },
        onSuccess: () => {
            onClose()
            queryClient.invalidateQueries(['user'])
        }
    })

    // handle Adding address
    const handleAddAddress = () => {
        const formData = new FormData()
        Object.keys(data).forEach(key => {
            formData.append(key, data[key])
        })
        mutate(formData)
    }

    return (
        <div className='bg-gray-100 rounded-lg px-5 lg:px-10 py-10 w-full max-w-4xl'>

            <p className='text-gray-600 text-sm mb-5 italic'>
                Please note: Fields with * are required to complete the form
            </p>

            <div className="space-y-5 ">
                {/* Firstname */}
                <div className='space-y-1'>
                    <p className="">Firstname *</p>
                    <Input placeholder="Firstname" id="firstname" value={data.firstname} onChange={handleInput} />
                </div>
                {/* Lastname */}
                <div className='space-y-1'>
                    <p className="">Lastname</p>
                    <Input placeholder="Lastname" id="lastname" value={data.lastname} onChange={handleInput} />
                </div>
                {/* Company */}
                <div className='space-y-1'>
                    <p className="">Company</p>
                    <Input placeholder="Company" id="company" value={data.company} onChange={handleInput} />
                </div>
                {/* Address 1 */}
                <div className='space-y-1'>
                    <p className="">Address 1 *</p>
                    <Input placeholder="Address 1" id="address_1" value={data.address_1} onChange={handleInput} />
                </div>
                {/* Address 2 */}
                <div className='space-y-1'>
                    <p className="">Address 2</p>
                    <Input placeholder="Address 2" id="address_2" value={data.address_2} onChange={handleInput} />
                </div>
                {/* City */}
                <div className='space-y-1'>
                    <p className="">City *</p>
                    <Input placeholder="City" id="city" value={data.city} onChange={handleInput} />
                </div>
                {/* Country */}
                <div className='space-y-1'>
                    <p className="">Country *</p>
                    <select onChange={(e) => setData({ ...data, country: e.target.value })}>
                        <option value="">--</option>
                        <option value="Ghana">Ghana</option>
                        <option value="Nigeria">Nigeria</option>
                        <option value="Togo">Togo</option>
                        <option value="UK">United Kingdom</option>
                    </select>
                </div>
                {/* Phone */}
                <div className='space-y-1'>
                    <p className="">Phone *</p>
                    <Input placeholder="Phone" id="phone" value={data.phone} onChange={handleInput} />
                </div>

                {/* Loging Error */}
                <LogError error={error} />

                {/* Add Button */}
                <div className='flex items-center gap-3'>
                    <Button onClick={handleAddAddress} loading={isPending}>Add Address</Button>
                    <Button white onClick={() => onClose()} > Cancel</Button>
                </div>
            </div>
        </div >
    )
}

export default AddAddress